import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { tupasUrl } from '../common/constants'
import AnimateHeight from 'react-animate-height';
import HamburgerMenu from 'react-hamburger-menu';

class StickyHandling extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      height: 0
    }
  }
  handleClick() {
    this.setState({
      open: !this.state.open,
      height: this.state.height === 0 ? 'auto' : 0,
    });
  }

	render() {
    const { height } = this.state;
		return (
      <div className="handling-container">
        <div className="handling-times-available">
          <Link to="/" className="logo-container">
          <div className="logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 65.89"><title>Reseptori</title><g id="Layer_2" data-name="Layer 2"><g id="Musta"><path id="Rectangle_1195" data-name="Rectangle 1195" d="M20.92,63.78h0a4.66,4.66,0,0,1-4.66-4.66h0a4.66,4.66,0,0,1,4.66-4.67h0a4.66,4.66,0,0,1,4.66,4.67h0A4.66,4.66,0,0,1,20.92,63.78Z"/><path id="Path_1078" data-name="Path 1078" d="M72.25,65.89a2,2,0,0,1-1.89-2.6c3.24-9.58,5.92-18.56,5.93-28.8s-2.7-21.68-6-31.68A2,2,0,0,1,72.26.22h58.68c19.36,0,35.26,16,34,35a33.1,33.1,0,0,1-33.19,30.65H72.25Z"/><rect id="Rectangle_1187" data-name="Rectangle 1187" x="52.6" y="52.54" width="13" height="13" rx="6.5" ry="6.5"/><path id="Rectangle_1188" data-name="Rectangle 1188" d="M63.88,49.06h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,63.88,49.06Z"/><path id="Rectangle_1189" data-name="Rectangle 1189" d="M64,32.13h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,64,32.13Z"/><path id="Rectangle_1190" data-name="Rectangle 1190" d="M58.75,13h0a6.5,6.5,0,0,1-6.5-6.5h0A6.5,6.5,0,0,1,58.75,0h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,58.75,13Z"/><rect id="Rectangle_1191" data-name="Rectangle 1191" x="34.49" y="53.04" width="12" height="12" rx="6" ry="6"/><path id="Rectangle_1193" data-name="Rectangle 1193" d="M44,32.13h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,44,32.13Z"/><path id="Rectangle_1194" data-name="Rectangle 1194" d="M39.47,13h0a6,6,0,0,1-6-6h0a6,6,0,0,1,6-6h0a6,6,0,0,1,6,6h0A6,6,0,0,1,39.47,13Z"/><path id="Rectangle_1196" data-name="Rectangle 1196" d="M24.45,30.63h0a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h0a5,5,0,0,1,5,5h0A5,5,0,0,1,24.45,30.63Z"/><path id="Rectangle_1197" data-name="Rectangle 1197" d="M20.19,12h0a4.81,4.81,0,0,1-4.82-4.81h0A4.82,4.82,0,0,1,20.19,2.4h0A4.82,4.82,0,0,1,25,7.21h0A4.81,4.81,0,0,1,20.19,12Z"/><path id="Rectangle_1201" data-name="Rectangle 1201" d="M45.16,47.23h0a4.67,4.67,0,0,1-4.68-4.67h0a4.67,4.67,0,0,1,4.68-4.67h0a4.68,4.68,0,0,1,4.68,4.67h0A4.68,4.68,0,0,1,45.16,47.23Z"/><path id="Rectangle_1223" data-name="Rectangle 1223" d="M4.89,30.51h0A4.89,4.89,0,0,1,0,25.63H0a4.89,4.89,0,0,1,4.89-4.88h0a4.89,4.89,0,0,1,4.89,4.88h0A4.89,4.89,0,0,1,4.89,30.51Z"/></g></g></svg>
          
          </div>
          <span>RESEPTORI</span>
          </Link>
          { /* 
            <span className="handling-title-mobile" onClick={ this.toggle }>Tällä hetkellä saatavilla olevat käsittelyajat <span className={ height === 0 ? "" : "rotate-arrow"}><i className="fas fa-chevron-down" data-fa-transform="shrink-2"></i></span></span>
            <span className="handling-title-desktop">Tällä hetkellä saatavilla olevat käsittelyajat</span>
          
            <AnimateHeight duration={ 300 } height={ height } >
              <div className="ul-wrapper">
              <ul>
                <li className="active">12 h</li>
                <li className="active">2 h</li>
                <li className="">20 min</li>
              </ul>
              </div>
            </AnimateHeight> 
            */}
        </div>

        <div className="handling-links-container">

          <div className="handling-links --desktop">
              <Link to="/tietoa-asiakkaalle">
                <button>Tietoa asiakkaalle</button>
              </Link>
              <Link to={this.props.loginPath} className="handling--login">
                <button>Kirjaudu sisään</button>
              </Link>
              <button className="create-account" onClick={() => window.location.replace(tupasUrl())}>LUO TILI</button>
            </div>


            <div className="handling-links --mobile">
              <AnimateHeight duration={ 300 } height={ height } >
                <div className="full-height-container">
                <Link to="/tietoa-asiakkaalle">
                  <button>Tietoa asiakkaalle</button>
                </Link>
                <Link to={this.props.loginPath} className="handling--login">
                  <button>Kirjaudu sisään</button>
                </Link>
                <button className="create-account" onClick={() => window.location.replace(tupasUrl())}>LUO TILI</button>
                </div>
              </AnimateHeight> 
            </div>

        </div>

        
        <div className="hamburger-menu hide-desktop">
          <HamburgerMenu
            isOpen={this.state.open}
            menuClicked={this.handleClick.bind(this)}
            width={24}
            height={14}
            strokeWidth={2}
            rotate={0}
            color='white'
            borderRadius={0}
            animationDuration={0.35}
          />
        </div>
        
        

      </div>
			)
	}
}

export default StickyHandling